(function(){
  var $body = document.querySelector('html body');

  setTimeout(function(){
    $body.classList.add('is-BodyFade');
  }, 1000);

})();